import { useState, useEffect } from "react";
import { Flame } from "lucide-react";
import axios from "axios";
import { useAuth } from "../App";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LikeButton = ({ itemType, itemId, size = "default" }) => {
  const { user } = useAuth();
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const fetchLikes = async () => {
      try {
        const res = await axios.get(`${API}/likes/${itemType}/${itemId}`, { withCredentials: true,
          headers: user ? { Authorization: `Bearer ${localStorage.getItem("token")}` } : {}
        });
        setCount(res.data.count);
        setLiked(res.data.user_liked);
      } catch (e) {}
    };
    fetchLikes();
  }, [itemType, itemId, user]);

  const handleToggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user) {
      toast.error("Please login to like");
      return;
    }
    setAnimating(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(`${API}/like/${itemType}/${itemId}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });
      setLiked(res.data.liked);
      setCount(prev => res.data.liked ? prev + 1 : prev - 1);
    } catch (e) {
      toast.error("Failed to update");
    }
    setTimeout(() => setAnimating(false), 300);
  };

  const isSmall = size === "sm";

  return (
    <button
      onClick={handleToggle}
      className={`inline-flex items-center gap-1.5 transition-all ${
        liked
          ? "text-orange-400"
          : "text-zinc-500 hover:text-orange-300"
      } ${animating ? "scale-125" : "scale-100"}`}
      data-testid={`like-btn-${itemType}-${itemId}`}
    >
      <Flame
        className={`${isSmall ? "w-4 h-4" : "w-5 h-5"} transition-all ${liked ? "fill-orange-400" : ""}`}
      />
      {count > 0 && (
        <span className={`${isSmall ? "text-xs" : "text-sm"} font-medium`}>{count}</span>
      )}
    </button>
  );
};

export default LikeButton;
